import { MdOutlineRepeat } from "react-icons/md";
import InfoBlock from "../InfoBlock/InfoBlock";
import { ICON_SIZES } from "src/helpers/constants";
import { IButton } from "../Button/Button";
import SlideDownUpAnimation from "../Animations/SlideDownUpAnimation";

interface IRecurringTransactionOrigin {
  transaction: any;
  buttons?: IButton[];
}

const RecurringTransactionOrigin: React.FC<IRecurringTransactionOrigin> = ({
  transaction,
  buttons,
}) => {
  return (
    <SlideDownUpAnimation show={transaction?.origin?.type === "RECURRING"}>
      <InfoBlock
        title="Movimiento recurrente"
        message="Este movimiento se generó desde una transacción recurrente."
        buttons={buttons}
        displayMobileIcon
        icon={<MdOutlineRepeat size={ICON_SIZES.MD} />}
      />
    </SlideDownUpAnimation>
  );
};

export default RecurringTransactionOrigin;
